import React from 'react';
import { Brain } from 'lucide-react';

/**
 * Reusable component for displaying intelligence data
 */
export default function IntelligenceDisplay({ intelligence }) {
  if (!intelligence) {
    return (
      <div className="rounded-xl shadow-sm border p-8" style={{ backgroundColor: '#FFFFFF', borderColor: '#D7B472' }}>
        <div className="flex items-center gap-2 mb-4">
          <Brain className="w-5 h-5" style={{ color: '#D7B472' }} />
          <h2 className="text-2xl font-semibold" style={{ color: '#0A0A10' }}>
            Your Intelligence
          </h2>
        </div>
        
        <div className="text-center py-12">
          <div className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center" style={{ backgroundColor: 'rgba(255, 107, 90, 0.15)' }}>
            <Brain className="w-8 h-8" style={{ color: '#FF6B5A' }} />
          </div>
          <h3 className="text-lg font-semibold mb-2" style={{ color: '#0A0A10' }}>
            No Intelligence Yet
          </h3>
          <p className="text-sm" style={{ color: '#0A0A10', opacity: 0.7 }}>
            Add your communication samples to generate your personalized intelligence profile.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-xl shadow-sm border p-8" style={{ backgroundColor: '#FFFFFF', borderColor: '#D7B472' }}>
      <div className="flex items-center gap-2 mb-4">
        <Brain className="w-5 h-5" style={{ color: '#D7B472' }} />
        <h2 className="text-2xl font-semibold" style={{ color: '#0A0A10' }}>
          Your Intelligence
        </h2>
      </div>
      
      <div className="space-y-4">
        {typeof intelligence === 'object' ? (
          Object.entries(intelligence).map(([key, value]) => (
            <div key={key} className="p-4 rounded-lg" style={{ backgroundColor: '#F8F7F4' }}>
              <h3 className="font-semibold mb-2 capitalize" style={{ color: '#FF6B5A' }}>
                {key.replace(/_/g, ' ')}
              </h3>
              {typeof value === 'object' && value !== null ? (
                <div className="space-y-2">
                  {Array.isArray(value) ? (
                    <ul className="list-disc list-inside space-y-1">
                      {value.map((item, idx) => (
                        <li key={idx} style={{ color: '#0A0A10', opacity: 0.8 }}>
                          {typeof item === 'object' ? JSON.stringify(item) : item}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    Object.entries(value).map(([subKey, subValue]) => (
                      <div key={subKey} className="ml-4">
                        <span className="font-medium" style={{ color: '#0A0A10' }}>
                          {subKey.replace(/_/g, ' ')}:{' '}
                        </span>
                        <span style={{ color: '#0A0A10', opacity: 0.8 }}>
                          {typeof subValue === 'object' ? JSON.stringify(subValue) : String(subValue)}
                        </span>
                      </div>
                    ))
                  )}
                </div>
              ) : (
                <p style={{ color: '#0A0A10', opacity: 0.8 }}>
                  {String(value)}
                </p>
              )}
            </div>
          ))
        ) : (
          <div className="p-4 rounded-lg whitespace-pre-wrap" style={{ backgroundColor: '#F8F7F4', color: '#0A0A10' }}>
            {intelligence}
          </div>
        )}
      </div>
    </div>
  );
}

